"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var colors = _interopRequireWildcard(require("@cimpress/react-components/lib/colors"));

var _Icon = _interopRequireDefault(require("@cimpress/react-components/lib/Icon"));

var _emotion = require("emotion");

var _react = _interopRequireWildcard(require("react"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin: 0 10px;\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _emotion.css)(_templateObject());

var PriceModelOptionToggle =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PriceModelOptionToggle, _PureComponent);

  function PriceModelOptionToggle() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, PriceModelOptionToggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(PriceModelOptionToggle)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onClick = function () {
      var _this$props = _this.props,
          selected = _this$props.selected,
          onSelect = _this$props.onSelect;
      onSelect && onSelect(!selected);
    };

    return _this;
  }

  (0, _createClass2.default)(PriceModelOptionToggle, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          selected = _this$props2.selected;
      var color = selected ? colors.success.base : colors.ocean.base;
      var name = selected ? 'check-circle-2-f' : 'check-circle-2-l';
      return _react.default.createElement("a", {
        className: (0, _emotion.cx)(style, className),
        role: "button",
        tabIndex: 0,
        onClick: this.onClick
      }, _react.default.createElement(_Icon.default, {
        color: color,
        name: name,
        size: "lg"
      }));
    }
  }]);
  return PriceModelOptionToggle;
}(_react.PureComponent);

var _default = PriceModelOptionToggle;
exports.default = _default;